import { IProjectSquad } from '../../models/projectSquad.model';
import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import {
  CLEAR_PROJECT_SQUAD,
  CREATE_PROJECT_SQUAD,
  FETCH_PROJECT_SQUAD,
  FETCH_PROJECT_SQUAD_LIST,
  UPDATE_PROJECT_SQUAD,
  DELETE_PROJECT_SQUAD,
} from './projectSquad.actions';
import { ProjectSquadState } from './projectSquad.types';

const getInitialProjectSquadState = (): IProjectSquad => ({});

const initialState: ProjectSquadState = {
  errorMessage: '',
  item: getInitialProjectSquadState(),
  items: [],
  loading: false,
  totalItems: 0,
};

export default (
  state: ProjectSquadState = initialState,
  action: AppAction,
): ProjectSquadState => {
  switch (action.type) {
    case REQUEST(FETCH_PROJECT_SQUAD_LIST):
    case REQUEST(CREATE_PROJECT_SQUAD):
    case REQUEST(FETCH_PROJECT_SQUAD):
    case REQUEST(UPDATE_PROJECT_SQUAD):
    case REQUEST(DELETE_PROJECT_SQUAD):
      return { ...state, loading: true };
    case SUCCESS(FETCH_PROJECT_SQUAD_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_PROJECT_SQUAD_LIST):
    case FAILURE(CREATE_PROJECT_SQUAD):
    case FAILURE(FETCH_PROJECT_SQUAD):
    case FAILURE(UPDATE_PROJECT_SQUAD):
    case FAILURE(DELETE_PROJECT_SQUAD):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case SUCCESS(CREATE_PROJECT_SQUAD):
    case SUCCESS(FETCH_PROJECT_SQUAD):
    case SUCCESS(UPDATE_PROJECT_SQUAD):
      return { ...state, loading: false, item: action.payload.data };
    case SUCCESS(DELETE_PROJECT_SQUAD):
      return { ...state, loading: false };
    case CLEAR_PROJECT_SQUAD:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
